import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { usePortalHelpHook } from "./PortalHelpHook";
// Set the default state values for each context
const PortalHelpContext = /*#__PURE__*/createContext({});
export const PortalHelpContextProvider = ({
  children
}) => {
  const portalHelp = usePortalHelpHook();
  return /*#__PURE__*/React.createElement(PortalHelpContext.Provider, {
    value: portalHelp
  }, children);
};
export const usePortalHelp = () => {
  return useContext(PortalHelpContext);
};
PortalHelpContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};